import React from "react"
import { Box, Container, Heading, Text, Flex, Image, Grid } from "theme-ui"
import ArrowPrimary from "../images/list-arrow-violet.svg"

const ServiceCollection = ({ block }) => {
  const { kicker, services } = block

  return (
    <Container
      sx={{
        mt: [2, 2, 4],
        pb: "0px!important",
      }}
    >
      <Box
        sx={{
          borderTop: "2px solid",
          borderColor: "primary",
        }}
      >
        <Text sx={{ display: "block" }} variant="kicker">
          {kicker}
        </Text>
      </Box>

      <Grid
        columns={[1, 1, 3]}
        gap={[2]}
        sx={{
          borderBottom: "2px solid",
          borderColor: "primary",
          pb: [5, 5, 5, 8],
          columnGap: 0,
          mt: 5,
        }}
      >
        {services.map((service, index) => (
          <Flex sx={{ flexDirection: "column", alignItems: "stretch", gap: 1 }}>
            <Box>
              <Image sx={{ maxWidth: "50px" }} src={ArrowPrimary} />
              <Heading
                sx={{ fontWeight: 500, fontSize: [3, 3, 2, "16px"], mb: 3 }}
                variant="h5"
              >
                {service.title}
              </Heading>
            </Box>
            <Box
              sx={{
                width: ["100%", "100%", "80%"],
                p: { color: "dark" },
              }}
              dangerouslySetInnerHTML={{ __html: service.body }}
            />
          </Flex>
        ))}
      </Grid>
    </Container>
  )
}

export default ServiceCollection
